import { Dialog } from '@busybusy/webapp-react-ui';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import IPosition from 'types/Position';
import SafetyTrainingsForm from '../forms/SafetyTrainingsForm';

export interface ISafetyTrainingsDetailProps {
  position: IPosition;
  onUpdate: () => Promise<any>;
  editable: boolean;
}

const SafetyTrainingsDetail = (props: ISafetyTrainingsDetailProps) => {
  const { position, onUpdate, editable } = props;

  const detailOpenable = useOpenable();

  const onSubmitForm = () => {
    detailOpenable.close();
    onUpdate();
  };

  return (
    <>
      <ProDetailsItem
        title={t('Trainings')}
        onClick={detailOpenable.open}
        value={position.performTraining ? (position.manageTraining ? t('Manage') : t('Perform Only')) : t('Off')}
        hint={t(
          'Allow the user to be assigned to conduct safety training meetings. They can also create new meetings but can only assign themselves as the instructor.'
        )}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={detailOpenable.isOpen} onClose={detailOpenable.close}>
        <SafetyTrainingsForm
          onSubmit={onSubmitForm}
          performTraining={position.performTraining ?? false}
          manageTraining={position.manageTraining ?? false}
          positionId={position.id}
        />
      </Dialog>
    </>
  );
};

export default SafetyTrainingsDetail;
